import React from "react";
import { connect } from "react-redux";
import { MaterialTextField } from "./MaterialInput";
import { reduxForm, Field, reset } from "redux-form";
import * as agent from "../agent";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import IconButton from '@material-ui/core/IconButton';
import InnerLink from './InnerLink';
import OuterLink from './OuterLink';
import { FormattedDate, FormattedTime } from "react-intl";
import Grid from '@material-ui/core/Grid';
import SubmitButton from './SubmitButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Typography from '@material-ui/core/Typography';

const securityGIBDD = ({contractId, vin, onAddGIBDDCheck, onResolveProblem, handleSubmit, gibdd = []}) => {
    return (
        <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
            <Grid container justify="center" spacing={16}>
                <Grid item className="maxwide-column">
                { gibdd.length ?
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Дата</TableCell>
                                <TableCell>Автор</TableCell>
                                <TableCell>Комментарий</TableCell>
                                <TableCell>&nbsp;</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { gibdd.map(({date, author: {id, fullname = ""} = {}, note, _id, status}, i) =>
                                <TableRow key={i}>
                                    <TableCell>
                                        <FormattedDate value={date}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                        <br />
                                        <FormattedTime value={date}
                                                       hour="numeric"
                                                       minute="numeric"
                                                       second="numeric" />
                                    </TableCell>
                                    <TableCell>
                                        { id ? <InnerLink href={`/user/${id}`} label={fullname.split(" ")[0]} /> : "" }
                                    </TableCell>
                                    <TableCell>
                                        {status && !note ? "Чисто" : note }
                                    </TableCell>
                                    <TableCell>
                                        <IconButton disabled={status} onClick={() => onResolveProblem("gibdd", _id)} >
                                            { status ? <CheckCircleOutlineIcon /> : <HighlightOffIcon /> }
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table> : <Typography paragraph>Проверок еще не было</Typography>
                }
                    <form className="common-form"
                          onSubmit={handleSubmit(check => onAddGIBDDCheck(contractId, check))} >
                          <Field component={MaterialTextField}
                                 name="note"
                                 placeholder="Чисто"
                                 label="Комментарий" />
                          <SubmitButton label="Добавить" />
                    </form>
                </Grid>
                <Grid item className="common-column">
                    <OuterLink href={`https://гибдд.рф/check/auto/#${vin}`} label={"Проверка на сайте"}/>
                </Grid>
            </Grid>
        </Paper>
    );
};

const SecurityGIBDD = connect(
    null,
    dispatch => ({
        onAddGIBDDCheck: (contractId, check) =>
            agent.Contract.addGIBDDCheck(contractId, check)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
            .then(dispatch(reset('security-gibdd'))),
        onResolveProblem: (table, checkId) =>
            agent.Contract.resolveProblem(table, checkId)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
    })
)(reduxForm({form: "security-gibdd"})(securityGIBDD));

export default SecurityGIBDD;



// WEBPACK FOOTER //
// ./src/components/SecurityGIBDD.js